import React, { useEffect, useRef, useState } from 'react';
import {
  DEFAULT_ANGLE,
  DEFAULT_COLORS,
  DEFAULT_DECAY,
  DEFAULT_NUMBER_OF_PARTICLES,
  DEFAULT_SPREAD,
  DEFAULT_START_VELOCITY,
} from './consts';
import { Container } from './styles';
import { ConfettiProps } from './types';
import { generateConfetti } from './utils';

export const Confetti: React.FC<ConfettiProps> = (props) => {
  const {
    active = false,
    animateOnMount = false,
    angle = DEFAULT_ANGLE,
    className,
    decay = DEFAULT_DECAY,
    colors = DEFAULT_COLORS,
    spread = DEFAULT_SPREAD,
    startVelocity = DEFAULT_START_VELOCITY,
    numberOfParticles = DEFAULT_NUMBER_OF_PARTICLES,
    ...confettiProps
  } = props;
  const [isActive, setIsActive] = useState(!animateOnMount);

  const confettiRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (active && active !== isActive) {
      setIsActive(true);
      generateConfetti({ angle, decay, colors, spread, startVelocity, numberOfParticles, root: confettiRef });
    } else if (!active && isActive === true) {
      setIsActive(false);
    }
  }, [active, angle, colors, confettiProps, decay, isActive, numberOfParticles, spread, startVelocity]);

  return <Container className={className} ref={confettiRef} />;
};
